import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DISH_TYPE_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDishTypeImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_DISH_TYPE_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateDishTypeImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.dishTypes.dishType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DISH_TYPE_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateDishTypeImageDetailsArgs(data) },
        dispatch,
        UPDATE_DISH_TYPE_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateDishTypeImageDetailsMutation
